import { lazy } from 'react';

// project imports
import MainLayout from 'shared/components/layout/MainLayout';
import Loadable from 'shared/components/ui-component/Loadable';
import { APPLICATION_ROUTES } from 'constants/routes';
import AuthGuard from 'shared/utils/route-guard/AuthGuard';
// sample page routing
const PostLoginRootRedirect = Loadable(lazy(() => import('./PostLoginRootRedirect')));
const DashboardPage = Loadable(lazy(() => import('pages/reports/Dashboard')));
const ConsolidatedReportPage = Loadable(lazy(() => import('pages/reports/ConsolidatedReport')));
const OperationalPLPage = Loadable(lazy(() => import('pages/reports/OperationalPL')));
const OrderingPage = Loadable(lazy(() => import('pages/ordering')));
const OrderingLayoutPage = Loadable(lazy(() => import('pages/ordering/OrderingLayout')));
const CheckoutPage = Loadable(lazy(() => import('pages/ordering/Checkout')));
const ConfirmationPage = Loadable(lazy(() => import('pages/ordering/Confirmation')));
const OrderStatusPage = Loadable(lazy(() => import('pages/ordering/OrderStatus')));
const OrderDetailPage = Loadable(lazy(() => import('pages/ordering/OrderDetail')));
const OrderEditPage = Loadable(lazy(() => import('pages/ordering/OrderEdit')));
const ReceiptingListPage = Loadable(lazy(() => import('pages/ordering/ReceiptingList')));
const ReceiptingDetailPage = Loadable(lazy(() => import('pages/ordering/ReceiptingDetail')));
const MarketingCalendarPage = Loadable(lazy(() => import('pages/ordering/MarketingCalendar')));
const FallbackPage = Loadable(lazy(() => import('pages/fallback')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
    path: '/',
    element: (
        <AuthGuard>
            <MainLayout />
        </AuthGuard>
    ),
    children: [
        {
            path: '',
            index: true,
            element: <PostLoginRootRedirect />
        },
        {
            path: '*',
            element: <FallbackPage />
        },
        {
            path: APPLICATION_ROUTES.dashboard,
            element: <DashboardPage />
        },
        {
            path: APPLICATION_ROUTES.consolidatedReport,
            element: <ConsolidatedReportPage />
        },
        {
            path: APPLICATION_ROUTES.operationalPLReport,
            element: <OperationalPLPage />
        },
        {
            path: APPLICATION_ROUTES.ordering.browse,
            element: <OrderingLayoutPage />,
            children: [
                { index: true, element: <OrderingPage /> },
                { path: 'checkout', element: <CheckoutPage /> }
            ]
        },
        {
            path: APPLICATION_ROUTES.ordering.confirmation,
            element: <ConfirmationPage />
        },
        {
            path: APPLICATION_ROUTES.ordering.status,
            element: <OrderStatusPage />
        },
        {
            path: APPLICATION_ROUTES.ordering.statusOrderDetail,
            element: <OrderDetailPage />
        },
        {
            path: APPLICATION_ROUTES.ordering.statusOrderEdit,
            element: <OrderEditPage />
        },
        {
            path: APPLICATION_ROUTES.ordering.receiptingList,
            element: <ReceiptingListPage />
        },
        {
            path: APPLICATION_ROUTES.ordering.receiptingDetail,
            element: <ReceiptingDetailPage />
        },
        {
            path: APPLICATION_ROUTES.ordering.marketingCalendar,
            element: <MarketingCalendarPage />
        }
    ]
};

export default MainRoutes;
